import LicenseSection from "./General/LicenseSection";
import SourcesSection from "./General/SourcesSection";
import PreserveSettingsSection from "./General/PreserveSettingsSection";
import ExportSection from "./General/ExportSection";

const GeneralSettings = () => {
  return (
    <>
      <LicenseSection />
      <SourcesSection />
      <PreserveSettingsSection />
      <ExportSection />
    </>
  );
};

export default GeneralSettings;
